<template>
  <div>
    <el-form ref="form" :model="dateForm" :rules="rule">
      <el-form-item :label="label" :label-width="labelWidth" :required="required">
        <el-row type="flex">
          <el-form-item prop="dateStart" class="form-flex-item" v-if="mode.includes('start')">
            <el-date-picker
              v-model="dateForm.dateStart"
              type="date"
              align="left"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsStart"
              :disabled="readOnly">
            </el-date-picker>
          </el-form-item>
          <span style="margin-right: 10px" v-if="mode === 'start-end'">至</span>
          <el-form-item prop="dateEnd" class="form-flex-item" ref="dateEnd"  v-if="mode.includes('end')">
            <el-date-picker
              v-model="dateForm.dateEnd"
              type="date"
              align="left"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsEnd"
              :disabled="readOnly || dateForm.longTermTag">
            </el-date-picker>
            <el-checkbox style="margin-left: 15px;" v-model="dateForm.longTermTag" :disabled="readOnly" @change="longTermTagChange">长期有效</el-checkbox>
          </el-form-item>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ExpiryDate',
  props: {
    label: {
      type: String,
      default: '有效期'
    },
    labelWidth: {
      type: String,
      default: '120px'
    },
    required: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    valueName: {
      type: String,
      default: ''
    },
    // 有效期模式，默认start-end：有起止时间，end: 只有终止时间
    mode: {
      type: String,
      default: 'start-end'
    }
  },
  data () {
    return {
      dateForm: {
        dateStart: '',
        dateEnd: '',
        longTermTag: false// 是否长期有效，结束日期不可选
      },
      rule: {
        dateStart: [{
          validator: (rule, value, callback) => {
            if (this.required && !value && this.mode.includes('start')) {
              callback(new Error('请选择' + this.label + '开始日期'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        dateEnd: [{
          validator: (rule, value, callback) => {
            if (this.required && !value && !this.dateForm.longTermTag && this.mode.includes('end')) {
              callback(new Error('请选择' + this.label + '结束日期'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      }
    }
  },
  computed: {
    pickerOptionsStart () {
      return {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }
    },
    pickerOptionsEnd () {
      return {
        disabledDate: function (time) {
          return time.getTime() < Date.now() - 8.64e6
        }
      }
    }
  },
  watch: {
    dateForm: {
      handler (val, oldVal) {
        const value = val
        value.valueName = this.valueName
        this.$emit('change', val)
      },
      deep: true
    },
    value: {
      handler (val, oldVal) {
        this.dateForm = val
      },
      deep: true
    }
  },
  mounted () {
    if (this.value) {
      this.dateForm = this.value
    }
  },
  methods: {
    longTermTagChange () {
      this.dateForm.dateEnd = ''
      this.$refs.dateEnd.clearValidate()
    }
  }
}
</script>

<style scoped>
    .form-flex-item {
        margin-right: 5px;
    }
</style>
